import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';

export default function SheetHeader({
  title = '',
  className = '',
  children = null
}) {
  return (
    <UiKit.Modal.Header
      title={title}
      titleWeight="bold"
      className={cn(styles.header, className)}
    >
      {children}
    </UiKit.Modal.Header>
  );
}
